import type { Event, EventVideoConference, EventWebinar } from 'models';
import { Modal, type ModalOptions } from 'ui';
import { OrganizationProvider } from 'features/organizations';
import { useCreateNodeOrganization } from '../hooks';
import { DuplicateEventForm } from './duplicate-event-form';

export type DuplicateEventModalOptions = {
  event: EventVideoConference | EventWebinar;
};

type P = {
  onCancel: () => void;
  onSuccess: (eventData: Event) => void;
  options: ModalOptions<DuplicateEventModalOptions>;
};

const DuplicateEventModal = ({ onCancel, onSuccess, options }: P) => {
  const createNodeOrganization = useCreateNodeOrganization();

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Duplicate Event" width="large">
      {options.isOpened ? (
        <Modal.HugContent>
          <OrganizationProvider id={options.event.channel?.organizationHashId}>
            {(organization) => (
              <DuplicateEventForm
                event={options.event}
                onCancel={onCancel}
                onSuccess={onSuccess}
                organization={createNodeOrganization({
                  nodeOrganizationId: options.event.channel?.organization,
                  organization,
                })}
              />
            )}
          </OrganizationProvider>
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default DuplicateEventModal;
